import { db } from '../../firebase';

// xross interface
import { REPORT_110 } from '../interface';

const CL_INQUIRY = 'report110';
/*
 * -----------------------------------------------------------------
 * filter を指定して通報一覧を取得する
 * -----------------------------------------------------------------
 */
export const getReportListByFilter = async (
  limitNum: number,
  lastData: any,
  filter?: Record<string, any> // 複数の検索条件を持つオブジェクトを追加
): Promise<REPORT_110[]> => {
  console.log(
    'getReportListByFilter filter=',
    filter,
    'limitNum=',
    limitNum,
    ' lastData=',
    lastData
  );
  try {
    let query = db.collection(CL_INQUIRY);
    // searchCriteria オブジェクトに基づいて検索条件を動的に追加
    // for (const key in filter) {
    //   if (filter.hasOwnProperty(key)) {
    //     query = query.where(key, '==', filter[key]);
    //   }
    // }

    const ss = await query
      .orderBy('createdAt', 'desc')
      .startAfter(lastData)
      .limit(limitNum)
      .get();

    const list = ss.docs.map(
      (doc) => ({ ...doc.data(), id: doc.id } as REPORT_110)
    );

    return list;
  } catch (e) {
    console.log('---------- getReportListByFilter error ', e);
  }
  return [];
};
